import script from "./ModulePlaylist.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModulePlaylist.vue?vue&type=script&setup=true&lang=ts"

import "./ModulePlaylist.vue?vue&type=style&index=0&id=707c728f&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-707c728f"]])

export default __exports__